import React, { useEffect, useRef, useState, useContext } from 'react'
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';

import Card from '../../../../Components/Card/Card'
import { getLabel } from "../../../../Services/Language/LanguageService";
import { baseLang } from "../../../../Lang/BaseLang";
import { ConfigContext } from "../../../../Context/ConfigContext/ConfigContext";
import { AuthContext } from "../../../../Context/AuthContext/AuthContext";
import AgGrid from '../../../../Components/Tables/AgGrid/AgGrid';


import { setTitlePage } from '../../../../Services/Config/ConfigService';
import { eliminarIPVideo, getRedVideo } from '../../../../../API/IT/DireccionesIP/DireccionesIPRouter';

import VideoCRUD from "./VideoCRUD"
import { toastShow } from '../../../../Services/ToastService';

const VideoScreen = () => {
    const toast = useRef(null);
    const { config } = useContext(ConfigContext);
    const { userAuth } = useContext(AuthContext);

    const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(false);
    const [video, setVideo] = useState([]);
    const [selected, setSelected] = useState([]);
    const [showDialog, setShowDialog] = useState(false);

    const getInfo = async () => {
        setLoading(true);
        const d = await getRedVideo();
        setVideo(d);
        setLoading(false);
    };

    const eliminarIP = async (datos) => {
      const resultado = await eliminarIPVideo(datos)
  
      if (resultado[0]?.ESTADO === 1) {
        toastShow(
          toast,
          "success",
          "Datos Eliminados",
          resultado[0]?.MENSAJE
        );
        getInfo();
      } else {
        toastShow(toast, "error", "Error", resultado[0]?.MENSAJE);
      }
    };

    const columns = [
        {
          header: "ID",
          headerEn:"ID",
          field: "IdDireccionIP",
          hidden: userAuth.IdRol === 1,
          className: "Xsmall",
          onCellDoubleClicked: ({ data }) => {
            setShowDialog(true);
            setSelected(data);
          },
        },
        {
          header: "IP",
          headerEn:"IP",
          field: "DireccionIP",
          onCellDoubleClicked: ({ data }) => {
            setShowDialog(true);
            setSelected(data);
          },
        },
        {
          header: "Ubicación",
          headerEn:"Location",
          field: "NombreDispositivo",
          onCellDoubleClicked: ({ data }) => {
            setShowDialog(true);
            setSelected(data);
          },
        },
        {
          header: "Tipo Dispositivo",
          headerEn:"Device Type",
          field: "TipoDispositivo",
        },
        {
          header: "Marca",
          headerEn:"Brand",
          field: "Marca",
        },
        {
          header: "Modelo",
          headerEn:"Model",
          field: "Modelo",
        },
        {
          header: "Serie",
          headerEn:"Series",
          field: "Serie",
        },
        {
          header: "Area",
          headerEn:"Area",
          field: "Area",
        },
        {
          header: "Comentario",
          headerEn:"Comment",
          field: "Comentarios",
        },
        {
            header: "Estado",
            headerEn: "Status",
            field: "IdStatus",
            className: "small",
            Format: "Estado", 
            filter:false,    
            frozen:true,
            alignFrozen:"right",
            body: (rowData) => ({ ID: rowData.StatusName, Estado: rowData.StatusName }),
          },
        {
          field: "IdDireccionIP",
          className: "",
          header: "",
          Format: "Botones",
          frozen: true,
          alignFrozen: "right",
          filter: false,
          Botones: [
            {
              icon: "pi pi-pencil",
              tooltip: "Editar",
              onClick: (rowData) => {
                setShowDialog(true);
                setSelected(rowData);
              },
            },
            {
              icon: "pi pi-trash",
              tooltip: "Eliminar",
              onClick: (rowData) => {
                eliminarIP(rowData)
              },
            },
          ],
        },
    ]

    const table = {
        Columns: columns,
        Data: video,
        loading: loading
    };


    useEffect(() => {
      setTitlePage(getLabel(baseLang, "video", config.language));
      getInfo();
    }, []);



    return (
        <div className=" p-fluid px-4" style={{ width: "100%", height: "100%", margin: "auto" }}>
            <Toast ref={toast} />
            <Card
                titulo={
                <div className='botones'>
                    <h3>{getLabel(baseLang, "video", config.language)}</h3>
                    <Button icon='pi pi-refresh' onClick={getInfo} />
                    <Button icon='pi pi-plus' severity='success' onClick={() => {
                        setShowDialog(true);
                        setSelected(null);
                    }} />
                </div>}
                contenido={<div className='p-4' style={{ height: '90vh' }}>
                    <AgGrid table={table} />
                </div>}
            />

            {showDialog && 
              <VideoCRUD 
                video={video}
                toastRef={toast} 
                showDialog={showDialog} 
                setShowDialog={setShowDialog}
                selected={selected} 
                getInfo={getInfo} 
                modo={selected ? "Editar" : "Crear"}/>
            }
        </div>
    )
}

export default VideoScreen;